import { jsx as _jsx } from "react/jsx-runtime";
import { useMediaQuery } from '../../hooks';
import { DatePickerDesktopContent } from './desktop-content';
import { DatePickerMobileContent } from './mobile-content';
export function DefaultContent(props) {
    const isMobile = useMediaQuery('(max-width: 639px)');
    if (isMobile) {
        return _jsx(DatePickerMobileContent, { ...props });
    }
    return _jsx(DatePickerDesktopContent, { ...props });
}
